import React, { useEffect, useState } from "react";
import axios from "axios";
import { LoginApi } from "apis/LoginApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword]       = useState("");
  const [loading, setLoading]         = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    axios.defaults.headers.common["x-api-key"] =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxOTU4NDk0NDY3NDY0MzE1NjQ5ODc0NTY0ODkyNiIsIm5hbWUiOiJTY2hlbWVzIEJvb29rIiwiaWF0IjoxNTE2MjM5MDIyfQ.uVUOR2U82nTjNccumsyggdScQh0DA5PdlwF_l0VUdfd";
    if (localStorage.getItem("token")) {
      navigate("/admin/brands");
    }
  }, []);

  const submit = () => {
    if (phoneNumber === "9584945558" && password === "Digiretail123#") {
      getToken({ mobile: phoneNumber, password });
    } else {
      toast("Wrong Credentials!", { type: "error" });
    }
  };

  const getToken = ({ mobile, password }) => {
    setLoading(true);
    LoginApi.GenerateToken({ mobile, password })
      .then((res) => {
        localStorage.setItem("token", `Bearer ${res.data.token}`);
        navigate("/admin/brands");
      })
      .catch((err) => {
        toast(err?.response?.data?.message ?? "Login failed. Please try again.", {
          type: "error",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      })
      .finally(() => setLoading(false));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") submit();
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{
        background: "linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%)",
      }}
    >
      {/* Card */}
      <div
        className="w-full max-w-sm rounded-2xl overflow-hidden"
        style={{
          background: "#fff",
          boxShadow: "0 20px 60px rgba(79,70,229,0.25)",
        }}
      >
        {/* Card header */}
        <div
          className="px-8 py-8 text-center"
          style={{
            background: "linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%)",
          }}
        >
          <div className="w-14 h-14 rounded-2xl bg-white/20 flex items-center justify-center mx-auto mb-3">
            <i className="fas fa-shield-alt text-2xl text-white" />
          </div>
          <h2 className="text-xl font-bold text-white">Admin Portal</h2>
          <p className="text-indigo-200 text-sm mt-1">SRR Enterprise</p>
        </div>

        {/* Form */}
        <div className="px-8 py-8">
          <div className="space-y-5">
            {/* Phone */}
            <div>
              <label
                className="block text-xs font-600 uppercase tracking-wider mb-1.5"
                style={{ color: "var(--color-text-muted)" }}
              >
                Phone Number
              </label>
              <div className="relative">
                <span className="absolute inset-y-0 left-3 flex items-center pointer-events-none"
                  style={{ color: "var(--color-text-muted)" }}>
                  <i className="fas fa-phone text-xs" />
                </span>
                <input
                  type="tel"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  onKeyDown={handleKeyDown}
                  placeholder="Enter phone number"
                  className="w-full pl-9 pr-4 py-2.5 text-sm rounded-lg outline-none transition-all"
                  style={{
                    border: "1px solid var(--color-border)",
                    color: "var(--color-text-primary)",
                    background: "#F8FAFC",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#4F46E5")}
                  onBlur={(e)  => (e.target.style.borderColor = "var(--color-border)")}
                />
              </div>
            </div>

            {/* Password */}
            <div>
              <label
                className="block text-xs font-600 uppercase tracking-wider mb-1.5"
                style={{ color: "var(--color-text-muted)" }}
              >
                Password
              </label>
              <div className="relative">
                <span className="absolute inset-y-0 left-3 flex items-center pointer-events-none"
                  style={{ color: "var(--color-text-muted)" }}>
                  <i className="fas fa-lock text-xs" />
                </span>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={handleKeyDown}
                  placeholder="Enter password"
                  className="w-full pl-9 pr-4 py-2.5 text-sm rounded-lg outline-none transition-all"
                  style={{
                    border: "1px solid var(--color-border)",
                    color: "var(--color-text-primary)",
                    background: "#F8FAFC",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#4F46E5")}
                  onBlur={(e)  => (e.target.style.borderColor = "var(--color-border)")}
                />
              </div>
            </div>

            {/* Submit */}
            <button
              onClick={submit}
              disabled={loading}
              className="btn-primary w-full py-2.5 flex items-center justify-center gap-2 rounded-lg"
            >
              {loading ? (
                <i className="fas fa-spinner fa-spin text-sm" />
              ) : (
                <>
                  <i className="fas fa-sign-in-alt text-sm" />
                  Sign In
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
